export default __webpack_public_path__ + "f46ce79557ec86e1e039f8570c7943b5.glb";